module.exports = __webpack_public_path__ + "static/media/CProject10.afbf28e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/CProject10.jpg
// module id = 80
// module chunks = 0